"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnswerOptionUnitOfMeasure = exports.QuestionType = exports.QuestionnaireExpireAction = void 0;
var QuestionnaireExpireAction = /*#__PURE__*/function (QuestionnaireExpireAction) {
  QuestionnaireExpireAction["NONE"] = "NONE";
  QuestionnaireExpireAction["DELETE"] = "DELETE";
  QuestionnaireExpireAction["ARCHIVE"] = "ARCHIVE";
  return QuestionnaireExpireAction;
}(QuestionnaireExpireAction || (exports.QuestionnaireExpireAction = QuestionnaireExpireAction = {}));
var QuestionType = /*#__PURE__*/function (QuestionType) {
  QuestionType["SingleSelect"] = "SingleSelect";
  QuestionType["MultiSelect"] = "MultiSelect";
  QuestionType["SingleSelectWithText"] = "SingleSelectWithText";
  QuestionType["MultiSelectWithText"] = "MultiSelectWithText";
  return QuestionType;
}(QuestionType || (exports.QuestionType = QuestionType = {}));
var AnswerOptionUnitOfMeasure = /*#__PURE__*/function (AnswerOptionUnitOfMeasure) {
  AnswerOptionUnitOfMeasure["number"] = "number";
  AnswerOptionUnitOfMeasure["string"] = "string";
  return AnswerOptionUnitOfMeasure;
}(AnswerOptionUnitOfMeasure || (exports.AnswerOptionUnitOfMeasure = AnswerOptionUnitOfMeasure = {}));

